export default "__VITE_ASSET__7e9c2ec8__"